// actions.js

/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { DOWNLOAD_TRANSCRIPT_DATA, DOWNLOAD_TRANSCRIPT_DATA_RECEIVED } = constants.downloadtranscriptConstants;

export default {
  DOWNLOAD_TRANSCRIPT_DATA,
  DOWNLOAD_TRANSCRIPT_DATA_RECEIVED,

  TranscriptCsvData: () => ({
    type: DOWNLOAD_TRANSCRIPT_DATA
  }),
  TranscriptCsvDataReceived: () => ({
    type: DOWNLOAD_TRANSCRIPT_DATA_RECEIVED
  })
};
